import React from "react";
import ModalContainer from './ModalContainer';
import Modal from './Modal';
import Cta from '@components/CTA';
import Cookies from 'js-cookie';
import GTM from "@utils/GTM";
const HEALTHCARE_PROFESSIONAL_COOKIE = "exparel_hcp_verified";

const EntryModal = ({ children }) => {
    // Check if we should show this modal based on cookie
    const shouldShowModal = React.useMemo(() => {
        // Only run in client-side environment
        if (typeof window !== 'undefined') {
            return !Cookies.get(HEALTHCARE_PROFESSIONAL_COOKIE);
        }
        return true;
    }, []);

    const handleHcpClick = (closeModal) => {
        // Set the cookie to remember user's choice (365 days expiry)
        Cookies.set(HEALTHCARE_PROFESSIONAL_COOKIE, "true", { expires: 365, path: '/' });
        closeModal();
    };

    // If cookie exists, don't show the modal
    if (!shouldShowModal) {
        return null;
    } else {
        GTM.trackOpenModal("HCPSiteEntry");
    }

    return (
        <ModalContainer autoOpen={true}>
            {({ showModal, openModal, closeModal }) => (
                <>
                    {/* Modal trigger button - only show if not auto-open */}
                    {!true && (
                        <button
                            onClick={openModal}
                            className="modal-trigger px-4 py-2 bg-dark_green text-white rounded-full"
                        >
                            {"Open Modal"}
                        </button>
                    )}

                    {/* The modal itself */}
                    <Modal
                        showModal={showModal}
                        closeModal={closeModal}
                        preventOutsideClose={true}
                        id="entry-modal"
                        dialogPanelClassName="rounded-all_48 w-full p-[50px] lg:p-[118px] !max-w-[886px] mx-auto [&>div]:!p-0"
                    >
                        {children}
                        <div className="flex flex-col lg:flex-row justify-center gap-4">
                            <Cta
                                text="Close"
                                onClick={() => {
                                    window.open('https://www.exparel.com', '_blank');
                                }}
                                className="w-full"
                                label="Patient or Caregiver"
                                theme="Light"
                                displayType="Link Type Button"
                            />
                            <Cta

                                text="Close"
                                onClick={() => handleHcpClick(closeModal)}
                                className="w-full text-center !px-0 lg:!px-8 dissmiss"
                                label="US Healthcare Professional"
                                theme="Light"
                                displayType="Link Type Button"
                            />
                        </div>
                    </Modal>
                </>
            )}
        </ModalContainer>
    )
}

export default EntryModal;